export const AKKO_DEVICES = 'Akko Devices'
export const AKKO_ACCOUNT = 'Akko Account'
export const DASHBOARD = 'Dashboard'
export const AKKO_CLAIMS = 'Akko Claims'
export const AKKO_DASHBOARD = 'Akko Dashboard'
export const AKKO_CLOUD_STORAGE = 'Akko Cloud Storage'
export const AKKO_FAQ = 'Akko FAQ'
export const AKKO_CONTACT = 'Akko Contact'
export const AKKO_MENTOR = 'Akko Mentor'



// WEBPACK FOOTER //
// ./src/constants/sidebar/sidebar.js